import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  button: {
    height: 40,
    borderRadius: 18,
    margin: 4,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
});
